import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";
import { boundaryContext } from "../../../App";
import NewModal from "../../../views/admin/Modal/NewModal";
import logo_main from "../../assets/unikwork-logo3x.png";
import { postRequest } from "../../axiosClient";
import {
  errorNotification,
  successNotification,
} from "../../toast-notification/common-toast";
import { GET_PROFILE, LOGOUT } from "../../utils";
import "./Sidebar.css";
import SidebarListItem, { styles } from "./SidebarListItem";
import AddUpdate from "../../addUpdate/AddUpdate";
import { Avatar } from "@mui/material";
import { Tooltip } from "@mui/material";
const Sidebar = ({ toggleSidebar, isSidebarOpen, setSidebarOpen }) => {
  const role = secureLocalStorage.getItem("role");
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const {
    profileImage,
    setProfileImage,
    setUserData,
    socket,
    setSocket,
    inboxCount,
    userData,
  } = useContext(boundaryContext);

  const removeAuditActiveTab = () => {
    secureLocalStorage.removeItem("activetab");
  };

  const data = SidebarListItem().sidebarItem[role];
  const headerData = SidebarListItem().headerListItem[role];

  const pathname = `${location.pathname.split("/")[1]}${location.pathname.split("/")[2]
    ? "/" + location.pathname.split("/")[2] + "/:id"
    : ""
    }`;
  const isPathnameActive = location.pathname.split("/")[1];
  // const [showTooltip, setShowTooltip] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [reload, setReload] = useState(false);

  const handlemyLogout = async () => {
    setLoading(true);
    try {
      if (socket && socket.connected) {
        socket.disconnect();
        setSocket(null);
      }

      const res = await postRequest(LOGOUT, navigate, navigate);
      if (res.type === 1) {
        if (res.response.data.success) {
          secureLocalStorage.clear();
          setLoading(false);
          navigate("/");
          successNotification(res.response.data.message);
        }
      }
      if (res.type === 2) {
        errorNotification(res.errormessage || res.errors);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleOptionClick = (selectedOption) => {
    setShowModal(true);
  };

  const customMenu = ({ innerProps, children }) => (
    <div
      {...innerProps}
      onMouseEnter={() => setMenuIsOpen(true)}
      style={{
        cursor: "pointer",
        position: "absolute",
        right: "10px",
        top: "0px",
      }}
    >
      <div
        style={{
          backgroundColor: "transparent",
          height: "10px",
          width: "20px",
        }}
      >
        {" "}
      </div>
      {children}
    </div>
  );

  const options = [
    {
      value: handleOptionClick,
      label: "Log Out",
    },
  ];

  const getMyProfile = async () => {
    const API_URL = GET_PROFILE;
    const Token = secureLocalStorage.getItem("token");
    setLoading(true);
    axios
      .get(API_URL, { headers: { Authorization: Token } })
      .then((response) => {
        const data = response?.data?.data;
        setUserData(data);
        setProfileImage(data?.profile_image);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getMyProfile();
  }, []);

  return (
    <>
      <nav className="fixed top-0 z-50 w-full bg-white">
        <div className="px-3 py-[16px] 2xl:py-[28px] lg:px-5 lg:pl-3 relative">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start rtl:justify-end">
              <button
                data-drawer-target="logo-sidebar"
                data-drawer-toggle="logo-sidebar"
                aria-controls="logo-sidebar"
                type="button"
                className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg hover:bg-gray-100 "
                onClick={toggleSidebar}
              >
                <RxHamburgerMenu style={{ fontSize: "20px" }} />
              </button>
              <div>
                <img
                  src={logo_main}
                  className="h-[22px] lg:h-[32px] ms-2 lg:ms-4 me-3 hidden lg:block"
                  alt="FlowBite Logo"
                />
                <img
                  src={logo_main}
                  className="h-[22px] lg:h-[32px] ms-2 lg:ms-4 me-3 lg:hidden"
                  alt="FlowBite Logo"
                />
                <div className="bg-[#00000014] h-[1px] w-[205px] absolute bottom-0 left-[25px]"></div>
              </div>
              {headerData?.map(({ title, to }, i) => {
                return (
                  pathname === to &&
                  !title.includes("Dashboard") && (
                    <span
                      key={i}
                      className="self-center text-[30px] font-semibold sm:text-2xl lg:pl-[115px]"
                    >
                      {title}
                    </span>
                  )
                );
              })}
            </div>
            <div className="flex items-center me-3">
              <div className="flex items-center ms-3">
                <div
                  onMouseEnter={() => setMenuIsOpen(true)}
                  onMouseLeave={() => setMenuIsOpen(false)}
                >
                  <button
                    type="button"
                    className="flex rounded-full items-center text-sm focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                    aria-expanded="false"
                    data-dropdown-toggle="dropdown-user"
                  >
                    {
                      <Avatar
                        className="w-[48px] h-[48px] rounded-full  object-cover border-[1px] border-[#d3d3d3]"
                        src={profileImage ? profileImage : ""}
                        alt="userphoto"
                      />
                    }
                    {
                      <span className="hidden md:block ml-2 text-[#000000] font-[500]">
                        {userData?.first_name || ""} {userData?.last_name || ""}
                      </span>
                    }
                  </button>
                  <Select
                    placeholder="For Comapny"
                    value={"For Comapny"}
                    onChange={(selectedOption) =>
                      handleOptionClick(selectedOption)
                    }
                    options={options}
                    styles={styles}
                    className="basic-single"
                    classNamePrefix="select"
                    name="severity_picker"
                    components={{ Menu: customMenu }}
                    isSearchable={false}
                    menuIsOpen={menuIsOpen}
                  />
                </div>
                {/* dropdown-- */}
              </div>
            </div>
          </div>
        </div>
      </nav>
      <aside
        id="logo-sidebar"
        className={`fixed top-0 left-0 z-40 h-screen pt-[110px] md:pt-[100px] lg:pt-[85px] 2xl:pt-[110px] transition-transform ${isSidebarOpen ? " w-64" : "-translate-x-full  w-fit "
          } bg-white  lg:translate-x-0 `}
        aria-label="Sidebar"
      >
        <div className="h-full px-3 pb-4  bg-white dark:bg-gray-800 relative">
          <div className="space-y-2 font-medium h-full overflow-y-auto ">
            {data?.map(
              (
                {
                  to,
                  title,
                  icon,
                  activeIcon,
                  show,
                  ricon,
                  disabled = false,
                  toolTipContent,
                },
                index
              ) => {
                const count = inboxCount || 0;
                return (
                  <div key={index}>
                    {
                      (!isSidebarOpen ? (
                        <Tooltip
                          title={disabled ? toolTipContent : title}
                          placement="right"
                          arrow
                        >
                          <div
                            onClick={() => {
                              if (!disabled) {
                                navigate(to);
                                if (window?.innerWidth < 1024)
                                  setSidebarOpen(false);
                                removeAuditActiveTab();
                              }
                            }}
                            className={`${isPathnameActive === to ||
                              isPathnameActive
                                ?.split("/")
                                .includes(to?.split("/")[1])
                              ? "sidebar__descTwo"
                              : ""
                              } ${disabled
                                ? "bg-[#efefef] cursor-not-allowed"
                                : "cursor-pointer"
                              } flex p-[10px] relative items-center transition duration-300 ease-in-out 
          ${!isSidebarOpen && "w-fit"}`}
                          >
                            {ricon ? (
                              <span
                                className={
                                  isPathnameActive === to
                                    ? "text-[#267072] text-[25px]"
                                    : "text-[#6f767e] text-[25px]"
                                }
                              >
                                {ricon}
                              </span>
                            ) : (
                              <img
                                src={
                                  isPathnameActive === to ? activeIcon : icon
                                }
                                alt="icon"
                              />
                            )}
                            <span
                              className={`${isPathnameActive === to
                                ? "sidebar__text__active"
                                : "sidebar__text"
                                } hover:text-[#292929] pl-[10px] transition duration-300 ease-in-out 
              ${!isSidebarOpen && "scale-x-0 w-0 hidden"}`}
                            >
                              {title}
                            </span>
                            {title === "Inbox" && count > 0 && (
                              <span className="bg-[#267072] text-white text-xs ml-1 font-normal h-[18px] w-[18px] flex justify-center items-center rounded-full">
                                {count}
                              </span>
                            )}
                          </div>
                        </Tooltip>
                      ) : (
                        <div
                          onClick={() => {
                            if (!disabled) {
                              navigate(to);
                              if (window?.innerWidth < 1024)
                                setSidebarOpen(false);
                              removeAuditActiveTab();
                            }
                          }}
                          className={`${isPathnameActive === to ||
                            isPathnameActive
                              ?.split("/")
                              .includes(to?.split("/")[1])
                            ? "sidebar__descTwo"
                            : ""
                            } ${disabled
                              ? "bg-[#efefef] cursor-not-allowed"
                              : "cursor-pointer"
                            } flex p-[10px] relative items-center transition duration-300 ease-in-out 
        ${!isSidebarOpen && "w-fit"}`}
                        >
                          {ricon ? (
                            <span
                              className={
                                isPathnameActive === to
                                  ? "text-[#267072] text-[25px]"
                                  : "text-[#6f767e] text-[25px]"
                              }
                            >
                              {ricon}
                            </span>
                          ) : (
                            <img
                              src={isPathnameActive === to ? activeIcon : icon}
                              alt="icon"
                            />
                          )}
                          <span
                            className={`${isPathnameActive === to
                              ? "sidebar__text__active"
                              : "sidebar__text"
                              } hover:text-[#292929] pl-[10px] transition duration-300 ease-in-out 
            ${!isSidebarOpen && "scale-x-0 w-0 hidden"}`}
                          >
                            {title}
                          </span>
                          {title === "Inbox" && count > 0 && (
                            <span className="bg-[#267072] text-white text-xs ml-1 font-normal h-[18px] w-[18px] flex justify-center items-center rounded-full">
                              {count}
                            </span>
                          )}
                        </div>
                      ))
                    }
                  </div>
                );
              }
            )}
          </div>
        </div>
      </aside>
      <NewModal
        title="Are you Sure?"
        onClose={() => setShowModal(false)}
        show={showModal}
      >
        <div className="modal-body add__cmp__form">
          <h6>Do you really want to log out?</h6>
          <div className="add__close__section">
            <button
              type="button"
              className="bg-[#F5F5F5] text-[#5D5D5D] w-[fit-content] px-4 py-2 rounded-[12px] me-3"
              onClick={() => setShowModal(false)}
            >
              No
            </button>
            <button
              type="button"
              className="bg-[#267072] text-[#fff] border-[1px] flex items-center  w-[fit-content] px-3 py-2 rounded-[12px] whitespace-nowrap"
              onClick={handlemyLogout}
              disabled={loading}
            >
              {loading && (
                <span
                  className="spinner-border spinner-border-sm  mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}{" "}
              Yes{" "}
            </button>
          </div>
        </div>
      </NewModal>
      <AddUpdate
        open={isOpen}
        setOpen={setIsOpen}
        getMyProfile={getMyProfile}
        setReload={setReload}
        reload={reload}
      />
    </>
  );
};

export default Sidebar;
